import { Box, Typography } from "@mui/material";
import type { FC } from "react";
import { SystemValidationTextField } from "../UIToolkit/Inputs/SystemValidationTextField";

type LocationCensusTabProps = {
	locations: string[];
	census: Record<string, number>;
	onCensusChange: (census: Record<string, number>) => void;
	totalCensus: number;
	unassignedCensus: number;
	censusValue: number;
};

export const LocationCensusTab: FC<LocationCensusTabProps> = ({ locations, census, onCensusChange, totalCensus, unassignedCensus, censusValue }) => {
	return (
		<Box sx={{ pt: 1 }}>
			<Box sx={{ display: "flex", flexDirection: "column", gap: 1, maxHeight: "200px", overflowY: "auto", pt: 0.6 }}>
				{locations.map((location) => (
					<SystemValidationTextField
						key={location}
						label={location}
						inputType="number"
						fullWidth
						value={String(census[location] || "")}
						onChange={(e) => {
							const value = e.target.value === "" ? 0 : +e.target.value;
							const otherLocationsTotal = Object.entries(census)
								.filter(([key]) => key !== location && locations.includes(key))
								.reduce((sum, [, val]) => sum + (val || 0), 0);
							const maxAllowed = censusValue - otherLocationsTotal;

							onCensusChange({
								...Object.fromEntries(locations.map((loc) => [loc, census[loc] || 0])),
								[location]: Math.max(0, Math.min(value, maxAllowed)),
							});
						}}
						injectedProps={{ slotProps: { htmlInput: { min: 0, max: censusValue } } }}
						formControlSx={{ width: "100%" }}
						reserveHeightForHelperText={false}
					/>
				))}
				<SystemValidationTextField
					label="Unassigned"
					inputType="number"
					fullWidth
					value={String(unassignedCensus)}
					disabled
					injectedProps={{ slotProps: { htmlInput: { readOnly: true } } }}
					formControlSx={{ width: "100%" }}
					reserveHeightForHelperText={false}
				/>
			</Box>
			<Typography variant="caption" sx={{ mt: 1, color: totalCensus > censusValue ? "error.main" : "text.secondary" }}>
				Total Assigned: {totalCensus} / {censusValue}
			</Typography>
		</Box>
	);
};
